import { React } from 'x'
import { createContext, useState } from 'react'

// Create context
export const AppContext = createContext([{}, () => {}])

export const AppProvider = (props) => {
  // Create context value using setState
  const [currentPage, setCurrentPage] = useState(1)

  // use context Provider to pass down demo state to children
  return (
    <AppContext.Provider value={[currentPage, setCurrentPage]}>
      {props.children}
    </AppContext.Provider>
  )
}
